import React, { useState, useEffect } from 'react';
import useStyles from '../../../styles';
import {
  TextField,
  Card,
  CardContent,
  Button,
} from '@material-ui/core';
import { formatDollar, formatPercentage } from '../../../lib/fmt';
import { Visibility as ViewIcon } from '@material-ui/icons';
import ClientSummarySegregationDetailsModal from './ClientSummarySegregationDetailsModal';

export default function ClientSummarySegregationFields({
  value,
}) {
  const classes = useStyles();
  const [segregationData, setsegregationData] = useState({});
  const [open, setOpen] = React.useState(false);

  useEffect(() => {
    setsegregationData(value);
  }, [value]);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <div>
      <Card className={classes.root} variant="outlined">
        <CardContent>
          <div>
            <form noValidate autoComplete="off">
              <div className={classes.grdRow}>
                <div className={classes.grdCell1} style={{ marginRight: 30 }}>
                  <TextField
                    label="Settle Date"
                    type="date"
                    fullWidth
                    InputProps={{
                      readOnly: true,
                    }}
                    InputLabelProps={{ shrink: true }}
                    value={segregationData.settleDate}
                  />
                </div>
                <div className={classes.grdCell1} style={{ marginRight: 30 }}>
                  <TextField
                    label="Master Account No"
                    fullWidth
                    InputProps={{
                      readOnly: true,
                    }}
                    InputLabelProps={{ shrink: true }}
                    value={segregationData.masterAccountNo}
                  />
                </div>
                <div className={classes.grdCell1}></div>
              </div>
              <div className={classes.grdRow}>
                <div className={classes.grdCell1} style={{ marginRight: 30 }}>
                  <TextField
                    label="Cash Balance"
                    fullWidth
                    InputProps={{
                      readOnly: true,
                    }}
                    InputLabelProps={{ shrink: true }}
                    value={formatDollar(segregationData.cashBalance) || formatDollar(0)}
                  />
                </div>
                <div className={classes.grdCell1} style={{ marginRight: 30 }}>
                  <TextField
                    label="Short Market Value"
                    fullWidth
                    InputProps={{
                      readOnly: true,
                    }}
                    InputLabelProps={{ shrink: true }}
                    value={formatDollar(segregationData.shortMarketValue) || formatDollar(0)}
                  />
                </div>
                <div className={classes.grdCell1}>
                  <TextField
                    label="Adjusted Balance"
                    fullWidth
                    InputProps={{
                      readOnly: true,
                    }}
                    InputLabelProps={{ shrink: true }}
                    value={formatDollar(segregationData.adjustedBalance) || formatDollar(0)}
                  />
                </div>
              </div>
              <div className={classes.grdRow}>
                <div className={classes.grdCell1} style={{ marginRight: 30 }}>
                  <TextField
                    label="Loan Rate"
                    fullWidth
                    InputProps={{
                      readOnly: true,
                    }}
                    InputLabelProps={{ shrink: true }}
                    value={segregationData.loanRate ? formatPercentage(segregationData.loanRate) : 0}
                  />
                </div>
                <div className={classes.grdCell1} style={{ marginRight: 30 }}>
                  <TextField
                    label="Loan Value"
                    fullWidth
                    InputProps={{
                      readOnly: true,
                    }}
                    InputLabelProps={{ shrink: true }}
                    value={formatDollar(segregationData.loanValue) || formatDollar(0)}
                  />
                </div>
                <div className={classes.grdCell1}>
                  <TextField
                    label="Long Market Value"
                    fullWidth
                    InputProps={{
                      readOnly: true,
                    }}
                    InputLabelProps={{ shrink: true }}
                    value={formatDollar(segregationData.longMarketValue) || formatDollar(0)}
                  />
                </div>
              </div>
              <div className={classes.grdRow}>
                <div className={classes.grdCell1} style={{ marginRight: 30 }}>
                  <TextField
                    label="Lockup"
                    fullWidth
                    InputProps={{
                      readOnly: true,
                    }}
                    InputLabelProps={{ shrink: true }}
                    value={segregationData.lockup}
                  />
                </div>
                <div className={classes.grdCell1} style={{ marginRight: 30 }}>
                  <TextField
                    label="Seg Amount"
                    fullWidth
                    InputProps={{
                      readOnly: true,
                    }}
                    InputLabelProps={{ shrink: true }}
                    value={formatDollar(segregationData.segAmt) || formatDollar(0)}
                  />
                </div>
                <div className={classes.grdCell1}>
                  <TextField
                    label="Excess Margin Amount"
                    fullWidth
                    InputProps={{
                      readOnly: true,
                    }}
                    InputLabelProps={{ shrink: true }}
                    value={formatDollar(segregationData.excessMarginAmt) || formatDollar(0)}
                  />
                </div>
              </div>
            </form>
          </div>
        </CardContent>
      </Card>

      <div className={classes.actionContainer}>
        <div className={classes.grdRow}>
          <Button
            variant="contained"
            color="primary"
            size="large"
            startIcon={<ViewIcon />}
            onClick={() => {
              handleOpen();
            }}
          >
            View Details
          </Button>
        </div>
      </div>

      {open && (
        <ClientSummarySegregationDetailsModal
          onClose={handleClose}
          open={open}
          value={segregationData}
        ></ClientSummarySegregationDetailsModal>
      )}

    </div>
  );
}
